<div class="pdf-page app-aul-032-24" id="aul03224">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> BIOLOGICAL OR CHEMICAL MATERIALS EXCLUSION </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    It is agreed that this Insurance excludes loss, damage, cost or expense of
    whatsoever nature directly or indirectly caused by, resulting from or in
    connection with the actual or threatened malicious use of pathogenic or
    poisonous biological or chemical materials regardless of any other cause or
    event contributing concurrently or in any other sequence thereto.
  </p>
</div>
